export const permissionsApis = {
    permissions: 'v1/api/permissions',
    createPermissions: 'v1/api/permissions',
    editPermissions: 'v1/api/permissions',
    deletePermissions: 'v1/api/permissions',
};
